import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import type { ProcedureItem } from 'features/Procedure/state/procedure-api.type'
import type { ReactNode } from 'react'
import { memo } from 'react'
import { ReactComponent as ExpandMinusIcon } from '../../assets/expand-minus.svg'
import { ReactComponent as ExpandPlusIcon } from '../../assets/expand-plus.svg'
import styles from '../../treatments.module.scss'
import { ProcedureNotesTable } from '../procedure-notes-table/procedure-notes-table'

type Props = {
  items: ProcedureItem[]
  columns: ColumnsType<ProcedureItem>
  getRowClassName: (record: ProcedureItem) => string
  expandedRowRender: (record: ProcedureItem) => ReactNode
  isFetching: boolean
}

export const TreatmentsDataSection = memo(
  ({ items, columns, getRowClassName, expandedRowRender, isFetching }: Props) => {
    return (
      <>
        <Table
          rowKey='id'
          dataSource={items}
          columns={columns}
          rowClassName={getRowClassName}
          loading={isFetching}
          tableLayout='auto'
          bordered
          className={styles.table}
          pagination={false}
          expandable={{
            expandedRowRender,
            expandIcon: ({ expanded, onExpand, record }) => (
              <button
                className={styles.expandIcon}
                onClick={(e) => onExpand(record, e)}
                type='button'>
                {expanded ? <ExpandMinusIcon /> : <ExpandPlusIcon />}
              </button>
            ),
          }}
        />
        <ProcedureNotesTable isLoading={isFetching} />
      </>
    )
  },
)

TreatmentsDataSection.displayName = 'TreatmentsDataSection'
